export async function getBlogs() {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/blogs`);
    const blogs = await response.json();
    return blogs;
  } catch (error) {
    console.log(error);
  }
}
